import DashboardService from "services/DashboardService";
import Utils from "utils";
import { create } from "zustand";
import { persist } from "zustand/middleware";

export const useDashboard = create(
  persist(
    (set, get) => ({
      widgets: [],
      indicadores: null,
      lastUpdate: null,
      lastUpdatePTBR: null,
      loading: false,
      refreshTimeout: false,
      setWidgetPosition: (widget, position, dimension) => {
        const index = get().widgets.findIndex((w) => w.widget === widget);
        if (index === -1) {
          set((state) => ({
            widgets: [...state.widgets, { widget, position, dimension }],
          }));
        } else {
          const widgets = [...get().widgets];
          widgets[index].position = position;
          widgets[index].dimension = dimension;
          set({ widgets });
        }
      },
      getWidgetPosition: (widget) => {
        const index = get().widgets.findIndex((w) => w.widget === widget);
        return index === -1 ? null : get().widgets[index].position;
      },
      sendRequestRefresh: async () => {
        set({ loading: true });
        try {
          const { status } = await DashboardService.requestRefresh();
          if (status === 200) {
            await Utils.timeout(6000);
            await get().getIndicadores();
          }
        } catch (error) {
          console.error("Erro na solicitação de atualização:", error);
        } finally {
          set({ loading: false, refreshTimeout: true });
        }
      },
      setRefreshTimeout: (status) => {
        set({ refreshTimeout: status });
      },
      getIndicadores: async () => {
        set({ loading: true });
        try {
          const timestamp = new Date().getTime();

          const { data, status } = await DashboardService.getIndicadores();

          if (status === 200) {
            // Verificar especificamente os dados de vazão
            if (data.averageWaterFlowHourly) {
              //   console.log(
              //     "Dados de vazão horária:",
              //     data.averageWaterFlowHourly
              //   );
            } else {
              console.warn(
                "Dados de vazão horária não encontrados na resposta"
              );
            }

            if (data.waterFlowDaily) {
              //   console.log("Dados de vazão semanal:", data.waterFlowDaily);
            } else {
              console.warn(
                "Dados de vazão semanal não encontrados na resposta"
              );
            }

            // Garantir que lastUpdate sempre seja uma data válida
            const validLastUpdate =
              data.lastUpdate && new Date(data.lastUpdate).getTime() > 0
                ? data.lastUpdate
                : new Date().toISOString();

            set({
              indicadores: data,
              lastUpdate: validLastUpdate,
              lastUpdatePTBR: Intl.DateTimeFormat("pt-BR").format(
                new Date(validLastUpdate)
              ),
            });

            try {
              sessionStorage.setItem(
                "dashboard_store_indicators",
                JSON.stringify(data)
              );
            } catch (storageError) {
              console.warn(
                "Erro ao salvar indicadores no sessionStorage:",
                storageError
              );
            }
          } else {
            console.warn("Resposta do servidor com status inesperado:", status);

            get().recoverFromStorage();
          }
        } catch (error) {
          console.error("Erro ao buscar indicadores:", error);

          get().recoverFromStorage();
        } finally {
          set({ loading: false });
        }
      },

      recoverFromStorage: () => {
        try {
          const storedData = sessionStorage.getItem(
            "dashboard_store_indicators"
          );
          if (storedData) {
            const parsedData = JSON.parse(storedData);

            // Garantir que lastUpdate sempre seja uma data válida
            const validLastUpdate =
              parsedData.lastUpdate &&
              new Date(parsedData.lastUpdate).getTime() > 0
                ? parsedData.lastUpdate
                : new Date().toISOString();

            set({
              indicadores: parsedData,
              lastUpdate: validLastUpdate,
              lastUpdatePTBR: Intl.DateTimeFormat("pt-BR").format(
                new Date(validLastUpdate)
              ),
            });

            return true;
          }
        } catch (error) {
          console.error("Erro ao recuperar dados do sessionStorage:", error);
        }
        return false;
      },

      resetStore: () => {
        set({
          indicadores: null,
          lastUpdate: null,
          lastUpdatePTBR: null,
        });
      },
    }),
    {
      name: "dash-storage",
      partialize: (state) => ({
        widgets: state.widgets,
      }),
    }
  )
);
